import {_} from 'lodash';
import * as ko from "knockout";
import {IMessageData, IRouteDefinitionParams, IRuleset} from "../../../index";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {createErrorMessage} from "../../../util/misc";
import {nsRoute} from "../../../util/route";
import {REQUEST_MESSAGE} from "../../../constants/Language";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;

export class Abstract extends ParsedRouteDataDecorator {
    protected readonly isReady: KnockoutObservable<boolean> = ko.observable(false);
    protected readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    protected data!: IRuleset;
    protected readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.initRequest();
    }

    protected initRequest(): Promise<any> {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        const req = this.__requestRouteData;
        if (!req) {
            return Promise.resolve();
        }
        return req
            .request()
            .then((data: any[]) => {
                const d = data[0] as IRuleset;
                d.rules = _.sortBy(d.rules, 'order');
                this.data = d;
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))));
    }
}